import { createLogger } from '@/core/helpers/logger.helper';

const logger = createLogger('LocalizationRepository');

export class LocalizationRepository {
  private translations: any | null;

  async getTranslations(language: string): Promise<any> {
    const translations = await import(`@/translations/${language}.json`);
    if (translations.default) {
      return translations.default;
    }

    throw new Error(`Translation "${language}" not found.`);
  }

  translationsForKey(key: string): string | null | undefined {
    return this.translations?.[key];
  }

  async setTranslations(language: string): Promise<void> {
    try {
      this.translations = await this.getTranslations(language);
    } catch {
      logger.error(`Could not found translation file for ${language} language`);
      this.translations = null;
    }
  }
}
